import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import Answer from "./Answer"

const UsersAnswer = ({ rawAnswer = {} }) => {
  const { user_ids: userIds = [] } = rawAnswer

  const users = useSelector(organizationUsersById(userIds), isEqual)

  const userNames = users.map((user) => user.fullName).join(", ")

  return (
    <Answer rawAnswer={userNames} />
  )
}

UsersAnswer.propTypes = {
  rawAnswer: types.shape({
    user_ids: types.arrayOf(types.number),
  }),
}

export default UsersAnswer
